import { useVoiceAssistant } from '@livekit/components-react';
import { useMemo } from 'react';
import {
  useTranscriptionStreams,
  type TranscriptionStreamSegment,
} from './useTranscriptionStreams';
import { TranscriptionRole } from '@shared/types/admin/conversation';
import { resolveRole } from '@shared/utils/livekit.utils';

export interface CombinedTranscriptionSegment {
  id: string;
  text: string;
  role: TranscriptionRole;
  firstReceivedTime: number;
  lastReceivedTime: number;
}

export const toCombinedTranscriptions = (
  segments: TranscriptionStreamSegment[],
  agentIdentity?: string,
): CombinedTranscriptionSegment[] =>
  segments
    .map((segment) => {
      const text = segment.text.trim();
      if (!text) return null;

      return {
        id: segment.id,
        text,
        role: resolveRole(segment.identity, agentIdentity),
        firstReceivedTime: segment.timestamp,
        lastReceivedTime: segment.timestamp,
      };
    })
    .filter((segment): segment is CombinedTranscriptionSegment => segment !== null)
    .sort((left, right) => left.firstReceivedTime - right.firstReceivedTime);

export default function useCombinedTranscriptions(): CombinedTranscriptionSegment[] {
  const segments = useTranscriptionStreams();
  const { agent } = useVoiceAssistant();
  const agentIdentity = agent?.identity;

  return useMemo(
    () => toCombinedTranscriptions(segments, agentIdentity),
    [segments, agentIdentity],
  );
}
